import globals from '@descope-ui/theme-globals';
import { getThemeRefs, createHelperVars } from '@descope-ui/common/theme-helpers';
import { TooltipClass, componentName } from './component/TooltipClass';

const globalRefs = getThemeRefs(globals);
const vars = TooltipClass.cssVarList;

const [helperTheme, helperRefs, helperVars] = createHelperVars(
  {
    shadowColor: '#00000020', // if we want to support transparency vars, we should use different color format
  },
  componentName
);

const { shadowColor } = helperRefs;
const defaultShadow = `${globalRefs.shadow.wide.sm} ${shadowColor}, ${globalRefs.shadow.narrow.sm} ${shadowColor}`;

const tooltip = {
  ...helperTheme,
  [vars.fontFamily]: globalRefs.fonts.font1.family,
  [vars.fontSize]: globals.typography.body2.size,
  [vars.fontWeight]: globals.typography.body2.weight,
  [vars.textColor]: globalRefs.colors.surface.contrast,
  [vars.hostDirection]: globalRefs.direction,
  [vars.backgroundColor]: globalRefs.colors.surface.main,
  [vars.borderColor]: globalRefs.colors.surface.light,
  [vars.borderStyle]: 'solid',
  [vars.borderWidth]: globalRefs.border.xs,
  [vars.borderRadius]: globalRefs.radius.xs,
  [vars.horizontalPadding]: globalRefs.spacing.md,
  [vars.verticalPadding]: globalRefs.spacing.sm,
  [vars.boxShadow]: defaultShadow,

  shadow: {
    sm: {
      [vars.boxShadow]: defaultShadow,
    },
    md: {
      [vars.boxShadow]: `${globalRefs.shadow.wide.md} ${shadowColor}, ${globalRefs.shadow.narrow.md} ${shadowColor}`,
    },
    lg: {
      [vars.boxShadow]: `${globalRefs.shadow.wide.lg} ${shadowColor}, ${globalRefs.shadow.narrow.lg} ${shadowColor}`,
    },
    xl: {
      [vars.boxShadow]: `${globalRefs.shadow.wide.xl} ${shadowColor}, ${globalRefs.shadow.narrow.xl} ${shadowColor}`,
    },
    '2xl': {
      [helperVars.shadowColor]: '#00000050', // mimic daisyUI shadow settings
      [vars.boxShadow]: `${globalRefs.shadow.wide['2xl']} ${shadowColor}`,
    },
  },
};

export default tooltip;
export { vars };
